import React, { Component } from 'react';
import { connect } from 'react-redux';
import Cookies from 'universal-cookie';
const cookies = new Cookies();

export class UserRankingWire extends Component {

  render() {
    const { client, server } = this.props

    if(server.userRanks.length === 0) {
      return( null )
    }

    const loc = cookies.get('locale')
    return(
      <div>
        <div className='UserRankingWire'
          style={{ transform: `translate3d(
          ${client.x['r']/3+(window.innerWidth/3)}px,
          ${client.y['r']/3+(window.innerHeight/3)}px, 0px)`}}>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  client: state.client,
  server: state.server
});

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(UserRankingWire)



// WEBPACK FOOTER //
// ./src/components/ranking/UserRankingWire.js